module.exports = __webpack_public_path__ + "img/Vector.49435dc.png";